export class CompanyOwnerEditModel {
    public id: number;
    public accountOwnerName: string;
    public accountOwnerEmail: string;
    public accountOwnerContactNumber: string;
    public accountOwnerTimeZone: string;
}
